import type { SiteRedirect } from './types';

/** Legacy URL 301s — App.tsx Navigate + public/.htaccess are generated from this list. */
export const SITE_REDIRECTS: SiteRedirect[] = [
  { from: '/ecommerce', to: '/ecommerce-development' },
  { from: '/seo-services', to: '/web-development' },
  { from: '/ourteam', to: '/leadership' },
  { from: '/carrer', to: '/career' },
  { from: '/blogdetail', to: '/blog' },
  { from: '/home', to: '/' },
  { from: '/web-host', to: '/website-maintenance' },
  { from: '/graphic', to: '/web-design' },
];
